import { useState } from "react";

const useVerifyCaptcha = () => {
    const [isVerified, setIsVerified] = useState(false);

    const verifyCaptcha = async (token) => {
        try {
            const response = await fetch(`/captcha/verify`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token }),
            });

            if (response) {
                const value = await response.json();
                setIsVerified(value);
                return value;
            } else {
                console.log("Response Error");
                return false;
            }
        } catch (err) {
            throw new Error("Error verifying captcha");
        }
    };

    return { isVerified, verifyCaptcha };
};

export default useVerifyCaptcha;
